module.exports = __webpack_public_path__ + "static/media/63.0cc64625.jpg";